import React, { PureComponent, PropTypes } from 'react';
import classNames from 'classnames';

import './TipControl.scss';

const PLACEMENT = ['top', 'bottom', 'left', 'right', 'auto'];

class TipControl extends PureComponent {

    static propTypes = {
        value: PropTypes.bool,
        className: PropTypes.string,
        label: React.PropTypes.string,
        placement: React.PropTypes.oneOf(PLACEMENT),
    }

    static defaultProps = {
        label: '',
        placement: 'top',
    }

    componentDidMount() {
        if (window.$ && typeof window.$(this.refs.TipControl).tooltip === 'function') {
            window.$(this.refs.TipControl).tooltip();
        }
    }

    render() {
        return (
            <div className={classNames('TipControl', this.props.className)}
                ref="TipControl"
                data-toggle="tooltip"
                data-placement={this.props.placement}
                // title={this.props.label}
                data-original-title={this.props.label}
            >
            </div>
        );
    }

}

export default TipControl;



// WEBPACK FOOTER //
// ./client/components/TipControl/TipControl.js